export default __webpack_public_path__ + "static/media/feeIcon.94608129.svg";